import Shuftipro from './Shuftipro';

export default Shuftipro;
